import relativeTime from "dayjs/plugin/relativeTime";

export const useApp = () => {
  const drawer = useState<boolean>('drawer', () => true)
  const errorState = useState('error', () => ({
    dialog: false,
    statusCode: 0,
    message: ''
  }));

  useDayjs().extend(relativeTime)

  return {
    drawer,
    errorState,
  }
}
